"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarMenu = void 0;
var react_1 = __importStar(require("react"));
var ArrowDropDown_1 = __importDefault(require("@mui/icons-material/ArrowDropDown"));
var css_1 = require("@emotion/css");
var styles_1 = require("@mui/material/styles");
var compose_react_refs_1 = __importDefault(require("@seznam/compose-react-refs"));
var Drawer_1 = require("../Drawer");
var Menu_1 = __importDefault(require("@mui/material/Menu"));
var prop_types_1 = __importDefault(require("prop-types"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var base_1 = require("@mui/base");
var ToolbarMenuClasses_1 = __importStar(require("./ToolbarMenuClasses"));
var useUtilityClasses = function (ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: ['root'],
        dropdownArrow: ['dropdownArrow'],
        icon: ['icon'],
        label: ['label'],
        cursorPointer: ['cursorPointer'],
        navGroups: ['navGroups'],
        rotatedDropdownArrow: ['rotatedDropdownArrow'],
    };
    return (0, base_1.unstable_composeClasses)(slots, ToolbarMenuClasses_1.getToolbarMenuUtilityClass, classes);
};
var Root = (0, styles_1.styled)(Typography_1.default, {})(function () {
    var _a;
    return (_a = {
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            maxWidth: 'fit-content'
        },
        _a["&.".concat(ToolbarMenuClasses_1.default.cursorPointer)] = { cursor: 'pointer ' },
        _a);
});
var DropDownArrow = (0, styles_1.styled)(ArrowDropDown_1.default, {})(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            marginLeft: theme.spacing(0.5)
        },
        _b["&.".concat(ToolbarMenuClasses_1.default.rotatedDropdownArrow)] = { transform: 'rotate(180deg)' },
        _b);
});
var ToolbarMenuIcon = (0, styles_1.styled)(Box_1.default, {})(function (_a) {
    var theme = _a.theme;
    return ({
        marginRight: theme.spacing(1),
        display: 'inline-flex',
        fontSize: 'inherit',
    });
});
var ToolbarMenuLabel = (0, styles_1.styled)(Box_1.default, {})(function () { return ({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
}); });
var ToolbarMenuNavGroups = (0, styles_1.styled)(Box_1.default, {})(function () { return ({
    '&:active, &:focus': {
        outline: 'none',
    },
}); });
var ToolbarMenuRenderer = function (props, ref) {
    var icon = props.icon, label = props.label, menu = props.menu, menuGroups = props.menuGroups, MenuProps = props.MenuProps, onClose = props.onClose, onOpen = props.onOpen, userClassName = props.className, _a = props.classes, classes = _a === void 0 ? {} : _a, otherTypographyProps = __rest(props, ["icon", "label", "menu", "menuGroups", "MenuProps", "onClose", "onOpen", "className", "classes"]);
    var theme = (0, styles_1.useTheme)();
    var rtl = theme.direction === 'rtl';
    var defaultClasses = useUtilityClasses(props);
    var _b = (0, react_1.useState)(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var anchor = (0, react_1.useRef)(null);
    var closeMenu = (0, react_1.useCallback)(function () {
        if (onClose) {
            onClose();
        }
        setAnchorEl(null);
    }, [onClose]);
    var openMenu = (0, react_1.useCallback)(function (event) {
        if (onOpen) {
            onOpen();
        }
        setAnchorEl(event);
    }, [onOpen]);
    (0, react_1.useEffect)(function () {
        if (menuGroups) {
            for (var _i = 0, menuGroups_1 = menuGroups; _i < menuGroups_1.length; _i++) {
                var group = menuGroups_1[_i];
                var _loop_1 = function (item) {
                    var onClick = item.onClick;
                    if (onClick) {
                        item.onClick = function (e) {
                            onClick(e);
                            closeMenu();
                        };
                    }
                };
                for (var _a = 0, _b = group.items; _a < _b.length; _a++) {
                    var item = _b[_a];
                    _loop_1(item);
                }
            }
        }
    }, [menuGroups]);
    var getMenu = (0, react_1.useCallback)(function () {
        if (menu && Boolean(anchorEl)) {
            return react_1.default.cloneElement(menu, __assign({ anchorEl: anchorEl, open: Boolean(anchorEl), onClose: closeMenu }, menu.props));
        }
        if (menuGroups && Boolean(anchorEl)) {
            return (react_1.default.createElement(Menu_1.default, __assign({ anchorOrigin: { vertical: 'bottom', horizontal: rtl ? 'right' : 'left' }, transformOrigin: { vertical: 'top', horizontal: rtl ? 'right' : 'left' }, anchorEl: anchorEl, open: Boolean(anchorEl), onClose: function () { return closeMenu(); } }, MenuProps, { MenuListProps: { style: { padding: 0 } } }), !menu &&
                menuGroups.map(function (group, index) { return (react_1.default.createElement(ToolbarMenuNavGroups, { className: defaultClasses.navGroups, key: index },
                    react_1.default.createElement(Drawer_1.DrawerNavGroup, { divider: false, hidePadding: true, itemIconColor: group.iconColor, itemFontColor: group.fontColor, title: group.title, items: group.items.map(function (item, itemIndex) {
                            return Object.assign({ itemID: itemIndex.toString() }, item);
                        }) }))); })));
        }
    }, [menuGroups, menu, anchorEl, MenuProps, defaultClasses]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Root, __assign({ ref: (0, compose_react_refs_1.default)(ref, anchor), "aria-haspopup": "true" }, otherTypographyProps, { className: (0, css_1.cx)(defaultClasses.root, classes.root, userClassName, menuGroups || menu ? defaultClasses.cursorPointer : ''), "data-testid": 'blui-menu-root', onClick: function () {
                openMenu(anchor.current);
            } }),
            icon && (react_1.default.createElement(ToolbarMenuIcon, { component: 'span', className: (0, css_1.cx)(defaultClasses.icon, classes.icon), "data-testid": 'blui-toolbar-menu-icon' }, icon)),
            react_1.default.createElement(ToolbarMenuLabel, { component: 'span', className: (0, css_1.cx)(defaultClasses.label, classes.label), "data-testid": 'blui-toolbar-menu-label' }, label || ''),
            (menuGroups || menu) && (react_1.default.createElement(DropDownArrow, { "data-testid": 'blui-arrow-dropdown', className: (0, css_1.cx)(defaultClasses.dropdownArrow, classes.dropdownArrow, anchorEl ? defaultClasses.rotatedDropdownArrow : '') }))),
        getMenu()));
};
/**
 * [ToolbarMenu](https://brightlayer-ui-components.github.io/react/components/toolbar-menu) component
 *
 * The `ToolbarMenu` used to display a dropdown menu with label.
 */
exports.ToolbarMenu = react_1.default.forwardRef(ToolbarMenuRenderer);
exports.ToolbarMenu.displayName = 'ToolbarMenu';
exports.ToolbarMenu.propTypes = {
    classes: prop_types_1.default.shape({
        root: prop_types_1.default.string,
        dropdownArrow: prop_types_1.default.string,
        icon: prop_types_1.default.string,
        label: prop_types_1.default.string,
    }),
    menu: prop_types_1.default.element,
    label: prop_types_1.default.string,
    icon: prop_types_1.default.element,
    // @ts-ignore
    menuGroups: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        title: prop_types_1.default.string,
        fontColor: prop_types_1.default.string,
        iconColor: prop_types_1.default.string,
        items: prop_types_1.default.arrayOf(prop_types_1.default.shape({
            icon: prop_types_1.default.element,
            onClick: prop_types_1.default.func,
            statusColor: prop_types_1.default.string,
            subtitle: prop_types_1.default.string,
            title: prop_types_1.default.string,
            divider: prop_types_1.default.bool,
        })),
    })),
    MenuProps: prop_types_1.default.object,
    onClose: prop_types_1.default.func,
    onOpen: prop_types_1.default.func,
};
exports.ToolbarMenu.defaultProps = {
    classes: {},
    menuGroups: [],
    MenuProps: {},
    onClose: function () { },
    onOpen: function () { },
};
